export enum StatusEnum {
    Pending = "Pending",
    InProgress = "InProgress",
    Ready = "Ready",
    Finish = "Finish",
    Failed = "Failed",
}